import { createSlice } from "@reduxjs/toolkit";
import editConsultationCharges from "@custom/rtk-apis/billing/consultation/editConsultationCharges";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const editConsultationChargesSlice = createSlice({
  name: "editConsultationChargesSlice",
  initialState,
  reducers: {
    clearEditConsultationCharges (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editConsultationCharges.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editConsultationCharges.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(editConsultationCharges.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default editConsultationChargesSlice.reducer;
export const { clearEditConsultationCharges } = editConsultationChargesSlice.actions;
